<template>
  <div class="pagestatu-container">
    <v-sheet
      v-show="statu ===0"
      :color="`grey ${$vuetify.theme.isDark ? 'darken-2' : 'lighten-4'}`"
      class
    >
      <v-skeleton-loader class="mx-auto" type="image,list-item@2,table-heading,date-picker"></v-skeleton-loader>
    </v-sheet>
    <v-sheet
      v-show="statu ===1"
      :color="`grey ${$vuetify.theme.isDark ? 'darken-2' : 'lighten-4'}`"
      class
    >
      <v-skeleton-loader class="mx-auto" type="image,list-item@2,table-heading,date-picker"></v-skeleton-loader>
    </v-sheet>

    <slot v-if="statu ===3">
      <div @click="refresh" class="flex-grow-1 align-center justify-center d-flex">加载失败，点击重试</div>
    </slot>
    
  </div>
</template>
<script>
//0未加载 1 加载中 2 加载完成 3 加载失败
export default {
  props: {
    statu: {
      type: [Number],
      default: -1
    },
    refresh: {
      type: [Function],
      default: () => {}
    }
  },
};
</script>
<style lang="scss" scoped>
.pagestatu-container {
  height: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
}
</style>